import React, { Component } from 'react';
import { Button, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import { translate } from 'react-i18next';
import Link from 'gatsby-link';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { userActions, alertActions } from '../../actions';
import PropTypes from 'prop-types';

class Signin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      submitted: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillUnmount() {
    this.props.dispatch(alertActions.clear());
  }
  handleChange(event) {
    this.setState({
      [event.target.id]: event.target.value,
    });
  }
  handleSubmit(event) {
    event.preventDefault();

    this.setState({ submitted: true });
    const { username, password } = this.state;
    const { dispatch } = this.props;
    if (username && password) {
      dispatch(userActions.login(username, password, this.props));
    }
  }
  validateForm() {
    return this.state.username.length > 0 && this.state.password.length > 0;
  }
  render() {
    const { t } = this.props;
    return (
      <div className="container col-6 flex-column">
        <div className="card-body">
          <div className="card text-center">
            <div className="card-header">{t('title')}</div>
            <span className="border"> </span>
            <form onSubmit={this.handleSubmit}>
              <div className="container col-6 flex-column">
                <FormGroup controlId="username">
                  <ControlLabel bsClass="sr-only">{t('login')}</ControlLabel>
                  <FormControl
                    autoFocus
                    type="text"
                    placeholder={t('login')}
                    onChange={this.handleChange}
                    bsClass="form-control"
                  />
                </FormGroup>
              </div>
              <div className="container col-6 flex-column">
                <FormGroup controlId="password">
                  <ControlLabel bsClass="sr-only">{t('password')}</ControlLabel>
                  <FormControl
                    type="password"
                    placeholder={t('password')}
                    onChange={this.handleChange}
                    bsClass="form-control "
                  />
                </FormGroup>
              </div>
              <Button
                bsClass="btn btn-sm btn-primary "
                disabled={!this.validateForm()}
                type="submit"
              >
                {t('signin')}
              </Button>

              <div className="border">
                <span className="border"> </span>
                <Link to="/register">{t('register_msg')} </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  return {
    loggingIn,
  };
}

Signin.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withRouter(
  connect(mapStateToProps)(translate('Signin')(Signin))
);



// WEBPACK FOOTER //
// ./src/components/Signin/index.js